module.exports = __webpack_public_path__ + "media/fonts/Oswald-48ff42da985a3593b5c84367c93f68c1.ttf";